import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { OnlineStatusController } from "./online-status.controller";
import { BaseComponent } from "../../../core/components/base.component";
import { OnlineStatusModel } from "./online-status.model";

@Component({
    selector: "online-status",
    template: `
        <div [ngClass]="{'light': busyStyle == 'light'}">
            <button
                ion-button
                clear
                (press)="onShowStatusOptions($event)"
                (click)="onClick()"

            >
                <ion-icon
                    name="warning"
                    *ngIf="!isOnline"
                ></ion-icon>

                <ion-spinner
                    name="dots"
                    *ngIf="busy && isOnline"
                ></ion-spinner>

                <ion-icon
                    [color]="busyStyle"
                    name="refresh"
                    *ngIf="!busy && isOnline"
                ></ion-icon>
            </button>

            <button
                *ngIf="showSignInButton && !isSignedIn"
                ion-button
                clear
                color="danger"
                (click)="onSignIn()"
            >
                <span class="fa fa-sign-in"></span>
            </button>
        </div>
    `,
    viewProviders: [
        OnlineStatusController
    ]
})
export class OnlineStatusComponent extends BaseComponent {
    @Input() busyStyle: string = "light";
    @Input() showSignInButton = true;

    protected model: OnlineStatusModel;

    constructor(
        protected controller: OnlineStatusController,
        protected changeDetectionRef: ChangeDetectorRef
    ) {
        super();
    }

    ngOnInit(): void {

        this.controller.model$
            .takeUntil(this.ngUnsubscribe)
            .subscribe(model => {
                this.model = model;
                this.changeDetectionRef.detectChanges();
            });

        this.controller.ngOnInit();
    }

    get isOnline(): boolean {
        return this.model ? this.model.isOnline : false;
    }
    get busy(): boolean {
        return this.model ? this.model.busy : false;
    }
    get isSignedIn(): boolean {
        return this.model ? this.model.isSignedIn : false;
    }

    onClick(): void {
        this.controller.refresh();
    }

    onShowStatusOptions($event): void {
        this.controller.showStatusOptions($event);
    }

    onSignIn(): void {
        this.controller.openSignInPage();
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/online-status/online-status.ts